/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_1_TitleInputs */

const en_mk_parts_1_title = /** @type {(inputs: Mk_Parts_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An issue tracker that stays light`)
};

const id_mk_parts_1_title = /** @type {(inputs: Mk_Parts_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue tracker yang ringan`)
};

/**
* | output |
* | --- |
* | "An issue tracker that stays light" |
*
* @param {Mk_Parts_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_1_title = /** @type {((inputs?: Mk_Parts_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_1_title(inputs)
	return en_mk_parts_1_title(inputs)
});